import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé. Vous pouvez vous connecter.");
      navigate("/admin/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-[#0a0b0e] border border-[#262a33] rounded-xl px-4 py-3 text-white placeholder:text-[#64697a] outline-none focus:ring-2 focus:ring-[#00e676]";

  return (
    <div className="min-h-screen bg-[#0a0b0e] flex items-center justify-center px-5">
      <div className="w-full max-w-sm bg-[#161920] border border-[#262a33] rounded-2xl p-7">
        <h1 className="font-display text-xl font-bold text-white mb-5">Nouveau mot de passe</h1>
        {!token ? (
          <p className="text-red-400 text-sm">Jeton manquant. <Link className="text-[#00e676]" to="/admin/forgot-password">Recommencer</Link></p>
        ) : (
          <form onSubmit={submit} className="flex flex-col gap-4">
            <input type="password" placeholder="Nouveau mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="reset-password" />
            <button disabled={loading} className="w-full bg-[#00e676] hover:bg-[#00c853] text-[#04120a] font-bold rounded-full py-3 flex items-center justify-center transition-colors disabled:opacity-60" data-testid="reset-submit">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Réinitialiser"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
